import Delete from '../../../../../../shared/Icons/Delete';
import TextField from '../../../../../../shared/TextField/TextField';
import Activities from '../../../../hooks/Levels/Activities';
import Activity from '../../Activity';
import AsyncButton from '../../../../../../shared/Loading/AsyncButton';

const EquivalentActivitiesAndBenefit = (props) => {
    const vm = Activities({row: props.row, setLevels: props.setLevels})

    return (
        <>
            <td className={`border border-gray-300 px-4 py-4 ${props.isEditor ? 'bg-gray-50' : 'bg-white'}`}>
                <div className="space-y-2">
                    {vm.activities.map((activity) =>
                        <div key={activity.Id} className="flex items-center gap-2">
                            {props.isEditor ? <Activity activity={activity} isEditor={true} setActivities={vm.setActivities}/>
                            : <ul className="list-disc pl-2">
                                <li><Activity activity={activity} isEditor={false} setActivities={vm.setActivities}/></li>
                            </ul>}
                            {props.isEditor && <AsyncButton light
                                onClick={() => props.deleteActivity(props.row.Id, activity.Id)}
                                className="p-1 text-red-500 hover:bg-red-50 rounded transition"
                            >
                                <Delete />
                            </AsyncButton>}
                        </div>
                    )}
                    {props.isEditor && <button
                        onClick={() => vm.handleAddActivity()}
                        className="w-full sm:w-auto px-4 py-2 text-sm border border-transparent text-white rounded
                        bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized"
                    >
                        + Agregar actividad
                    </button>}
                </div>
            </td>
            <td className={`border border-gray-300 px-4 py-4 ${props.isEditor ? 'bg-gray-50' : 'bg-white'}`}>
                <TextField
                    isEditor={props.isEditor}
                    id={props.row.Id}
                    field="Benefit"
                    value={props.row.Benefit || ''}
                    setData={props.setLevels}
                    className={'text-sm text-gray-700 whitespace-pre-line break-words'}
                />
            </td>
        </>
    )
};

export default EquivalentActivitiesAndBenefit;
